import { useSyncExternalStore } from 'react';
import { BackgroundJobsState, hasActiveJobs } from './backgroundJobsReducer';
import { backgroundJobsStore } from './BackgroundJobsStore';

/** Состояние фоновых задач вкладки: перерисовка на каждое изменение. */
export const useBackgroundJobs = (): BackgroundJobsState =>
    useSyncExternalStore(backgroundJobsStore.subscribe, backgroundJobsStore.getSnapshot);

const getHasActiveJobs = (): boolean => hasActiveJobs(backgroundJobsStore.getSnapshot());

/** Идёт ли хоть одна задача: перерисовка только при смене ответа, а не на каждый ход задачи. */
export const useHasActiveJobs = (): boolean => useSyncExternalStore(backgroundJobsStore.subscribe, getHasActiveJobs);

/** Задачи, чей файл сейчас скачивается: перерисовка только при смене состава. */
export const useJobDownloads = (): ReadonlySet<string> =>
    useSyncExternalStore(backgroundJobsStore.subscribeDownloads, backgroundJobsStore.getDownloads);
